import request from "@/util/http";

// 获取服务器时间
export function getTimes(query) {
    return request({
        url: "/admin/utils/curTime",
        method: "get",
        params: query
    });
}


// 获取用户权限
export function getUserPermissions(query) {
    return request({
        url: "/admin/user/info",
        method: "get",
        params: query
    });
}

export function loginTwos(query) {
    return request({
        url: "/auth/mobile/token/socia",
        method: "post",
        data: query
    });
}
// 获得用户分页
export function getUserPage(query) {
    return request({
        url: "admin/user/page",
        method: "get",
        params: query
    });
}
// 修改密码
export function changeOldPwd(row) {
    return request({
        url: "admin/user/changePassword/" + row.password,
        method: "get",
        params: row
    });
}
// 验证密码
export function validateOldPwd(row) {
    return request({
        url: "admin/user/validateOldPassword/" + row.password,
        method: "get",
        params: row
    });
}

// 获取默认页
export function getDefaultPage(row) {
    return request({
        url: "admin/menu/default/page",
        method: "get",
        params: row
    });
}

// 获取微信绑定信息
export function checkBound() {
    return request({
        url: "weixin/binding/checkBound",
        method: "get"
    });
}
// 解除微信绑定
export function unbundling() {
    return request({
        url: "weixin/binding/unbundling",
        method: "get"
    });
}
// 获取微信绑定二维码
export function getQRCode() {
    return request({
        url: "weixin/binding/getQRCode",
        method: "get"
    });
}
// 获取关注微信公众号二维码
export function getFocusQRCode() {
    return request({
        url: "weixin/binding/follow/getQRCode",
        method: "get"
    });
}

// 编辑个人信息
export function editPersonalInfo(query) {
    return request({
        url: "/admin/user/updatePhone",
        method: "get",
        params: query
    });
}
// 头像上传
export function uploadHeadPortrait(query) {
    var fileObj = query;
    var form = new FormData();
    form.append("file", fileObj);
    form.append("fileName", query.name);
    return request({
        url: "admin/binding/test",
        method: "post",
        data: form
    });
}
// 获取当前用户的授权人键值对
export function getCertigiers(query) {
    return request({
        url: "/admin/accredit/getCertigiers",
        method: "get",
        params: query
    });
}
// 获取当前用户的委派代理人列表
export function getAccreditPage(query) {
    return request({
        url: "/admin/accredit/page",
        method: "get",
        params: query
    });
}
// 获取当前用户的所有委派代理人
export function getAllAgents(query) {
    return request({
        url: "/admin/accredit/getAgents",
        method: "get",
        params: query
    });
}
// 新增委派代理人
export function addAccreditItem(query) {
    let params = "";
    query.forEach(item => {
        params += `ids=${item}&`;
    });
    return request({
        url: "/admin/accredit",
        method: "post",
        data: params
    });
}
// 删除委派代理人
export function delAccreditItem(query) {
    return request({
        url: `/admin/accredit/${query}`,
        method: "delete"
    });
}
// 获取logo
export function getLogoImg(query) {
    return request({
        url: "/admin/logo/imgAndName",
        method: "get",
        params:query
    });
}

// 保存logo
export function saveLogo(query) {
    return request({
        url: "/admin/logo",
        method: "post",
        data:query
    });
}


export function img(query) {
    return request({
        url: "/admin/formSheets/files?schoolYearId="+ query,
        method: "post",
        data: query
    });
}
// 获得注册用户分页
export function getRegisterUserPage(query) {
    return request({
        url: "/nnjs/thirdParty/page",
        method: "get",
        params: query
    });
}
// 注册用户审核
export function setRegisterStatus(query) {
    return request({
        url: "/nnjs/thirdParty/exameine",
        method: "post",
        data:query
    });
}

// 获取企业id
export function getDdQyId(query) {
    return request({
        url: "/admin/dingtalk/config",
        method: "get",
        params:query
    });
}

//多平台验证通过后正常登录
export function saveLogin(query) {
    return request({
        url: "/auth/mobile/token/login",
        method: "post",
        params:query,
        headers:{
            "Authorization": 'Basic ZGxic2R0OjVATS4qLyk1cSQoLw=='
        },
    });
}